if (!customElements.get('product-accordion')) {
  customElements.define(
    'product-accordion', 
class ProductAccordion extends HTMLElement {
  constructor() {
    super();
    this.attachEventListeners = this.attachEventListeners.bind(this);
    this.toggleAccordion = this.toggleAccordion.bind(this);
  }

  connectedCallback() {
    this.attachEventListeners();
  }

  attachEventListeners() {
    const accordionHeaders = this.querySelectorAll('.accordion__header');
    
    accordionHeaders.forEach(header => {
      header.addEventListener('click', this.toggleAccordion);
    });
  }

  toggleAccordion(event) {
    const header = event.target.closest('.accordion__header');
    if (!header) return;

    const accordion = header.parentElement;
    const content = accordion.querySelector('.accordion__content');
    
    const isOpen = content.classList.contains('open');
    
    document.querySelectorAll('.accordion__content').forEach(item => {
      item.classList.remove('open');
      item.style.maxHeight = '0';
      item.parentElement.querySelector('.accordion__header').classList.remove('active');
    });
    
    if (!isOpen) {
      content.classList.add('open');
      content.style.maxHeight = content.scrollHeight + 'px';
      header.classList.add('active');
    }
  }

  disconnectedCallback() {
    const accordionHeaders = this.querySelectorAll('.accordion__header');
    
    accordionHeaders.forEach(header => {
      header.removeEventListener('click', this.toggleAccordion);
    });
  }
}
  )
}

